<template>
  <div class="flex grow flex-col items-center justify-center">
    <RevLoadingScreen
      data-qa="loading-screen"
      data-test="loading-screen"
      :text="loadingText"
    />
  </div>
</template>

<script lang="ts" setup>
import { RevLoadingScreen } from '@ds/components/LoadingScreen'

import type { LoadingScreenProps } from './LoadingScreen.types'

defineProps<LoadingScreenProps>()
</script>
